import type { Specialty } from "@dentos/contracts";
import { useSession } from "./session";

/*
 * Clinic type (dental / ayurveda). Screens ask useIsDental() before showing tooth charts, tooth numbers and
 * dental labs, and take changing words from useTerms(), so one code base serves both editions.
 */

export function useSpecialty(): Specialty {
  return useSession().session?.activeTenant?.specialty ?? "dental";
}

export const useIsDental = () => useSpecialty() === "dental";

export interface Terms {
  /** A treatment position in a room: dental chair / therapy table (droni). */
  chair: string;
  chairs: string;
  Chair: string;
  Chairs: string;
  /** The treating clinician. */
  doctor: string;
  Doctor: string;
  /** Label for the doctor type stored as general_dentist. */
  generalDoctor: string;
}

const TERMS: Record<Specialty, Terms> = {
  dental: { chair: "chair", chairs: "chairs", Chair: "Chair", Chairs: "Chairs", doctor: "dentist", Doctor: "Dentist", generalDoctor: "General dentist" },
  ayurveda: { chair: "therapy table", chairs: "therapy tables", Chair: "Therapy table", Chairs: "Therapy tables", doctor: "physician", Doctor: "Physician", generalDoctor: "General physician" },
};

export const termsFor = (s: Specialty): Terms => TERMS[s];
export const useTerms = (): Terms => TERMS[useSpecialty()];
